import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/Flowers.css";
import LazyImage from "../components/LazyImage";
import SortSelector from "../components/SortSelector"; // Import the new component

const SearchResults = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { results, query } = location.state;

  const [sortedResults, setSortedResults] = useState([]);
  const [sortOption, setSortOption] = useState("default");

  // Apply sorting whenever results or sort option changes
  useEffect(() => {
    if (!results || results.length === 0) {
      setSortedResults([]);
      return;
    }

    // Create a copy to avoid mutating the original array
    const resultsCopy = [...results];

    switch (sortOption) {
      case "price-asc":
        // Sort by price ascending (cheapest first)
        resultsCopy.sort((a, b) => {
          // Convert price strings to numbers for comparison
          const priceA = parseFloat(
            a.price.replace(/[^\d,.]/g, "").replace(",", ".")
          );
          const priceB = parseFloat(
            b.price.replace(/[^\d,.]/g, "").replace(",", ".")
          );
          return priceA - priceB;
        });
        break;

      case "price-desc":
        // Sort by price descending (most expensive first)
        resultsCopy.sort((a, b) => {
          const priceA = parseFloat(
            a.price.replace(/[^\d,.]/g, "").replace(",", ".")
          );
          const priceB = parseFloat(
            b.price.replace(/[^\d,.]/g, "").replace(",", ".")
          );
          return priceB - priceA;
        });
        break;

      default:
        // Default sorting (no change)
        // You could add your default sorting logic here if needed
        break;
    }

    setSortedResults(resultsCopy);
  }, [results, sortOption]);

  const handleSortChange = (option) => {
    setSortOption(option);
  };

  const handleFlowerClick = (flowerId) => {
    navigate(`/flower/${flowerId}`);
  };

  return (
    <div className="section flower-section">
      <h1 className="heading-secondary">Rezultatele căutării: "{query}"</h1>

      {sortedResults.length === 0 ? (
        <p className="no-results">
          Nu a fost găsită nici o floare care să se potrivească cu selecția ta.{" "}
        </p>
      ) : (
        <>
          {/* Add the sort selector */}
          <SortSelector
            onSortChange={handleSortChange}
            currentSort={sortOption}
          />

          <div className="flower-grid">
            {sortedResults.map((flower) => (
              <div
                key={flower.id}
                className="flower-card"
                onClick={() => handleFlowerClick(flower.id)}
              >
                <LazyImage src={flower.images[0]} alt={flower.name} />
                <h3 className="flowerName">{flower.name}</h3>
                <p className="flowerPrice">{flower.price}</p>
                <button
                  className="btn buyNow"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleFlowerClick(flower.id);
                  }}
                >
                  Comanda acum
                </button>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default SearchResults;
